import { render, staticRenderFns } from "./ShaMfDataPop.vue?vue&type=template&id=e216d5e0"
import script from "./ShaMfDataPop.vue?vue&type=script&lang=js"
export * from "./ShaMfDataPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e216d5e0')) {
      api.createRecord('e216d5e0', component.options)
    } else {
      api.reload('e216d5e0', component.options)
    }
    module.hot.accept("./ShaMfDataPop.vue?vue&type=template&id=e216d5e0", function () {
      api.rerender('e216d5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShaMfDataPop.vue"
export default component.exports